import type { CustomFieldEntry, CustomFieldValueType } from '../../../../core/entities/node';
import { useLocale } from '../../../preferences/i18n/LocaleProvider';

const VALUE_TYPES: CustomFieldValueType[] = ['text', 'longtext', 'url', 'email', 'number', 'date'];

export function CustomFieldsPanel({ fields, onChange }: { fields: CustomFieldEntry[]; onChange: (fields: CustomFieldEntry[]) => void }) {
	const { t } = useLocale();
	const orderedFields = [...fields].sort((a, b) => a.displayOrder - b.displayOrder);

	function updateField(fieldId: string, patch: Partial<CustomFieldEntry>) {
		onChange(fields.map((field) => field.fieldId === fieldId ? { ...field, ...patch } : field));
	}

	function removeField(fieldId: string) {
		onChange(fields.filter((field) => field.fieldId !== fieldId).map((field, index) => ({ ...field, displayOrder: index })));
	}

	return (
		<section aria-label="Custom fields" style={{ display: 'grid', gap: 12 }}>
			<h3 style={{ margin: 0 }}>{t('customFields')}</h3>
			{orderedFields.map((field) => (
				<div key={field.fieldId} style={{ display: 'grid', gap: 8, padding: 12, borderRadius: 14, border: '1px solid rgba(170, 214, 255, .12)', background: 'rgba(7, 15, 32, .36)' }}>
					<label style={{ display: 'grid', gap: 6 }}>
						<span>{t('fieldLabel')}</span>
						<input className="hud-input" value={field.label} onChange={(event) => updateField(field.fieldId, { label: event.target.value })} />
					</label>
					<label style={{ display: 'grid', gap: 6 }}>
						<span>{t('fieldValue')}</span>
						<input className="hud-input" value={field.value} onChange={(event) => updateField(field.fieldId, { value: event.target.value })} />
					</label>
					<label style={{ display: 'grid', gap: 6 }}>
						<span>{t('valueType')}</span>
						<select className="hud-input" value={field.valueType} onChange={(event) => updateField(field.fieldId, { valueType: event.target.value as CustomFieldValueType })}>
							{VALUE_TYPES.map((valueType) => (
								<option key={valueType} value={valueType}>{valueType}</option>
							))}
						</select>
					</label>
					<label style={{ display: 'grid', gap: 6 }}>
						<span>{t('displayOrder')}</span>
						<input className="hud-input" type="number" value={field.displayOrder} onChange={(event) => updateField(field.fieldId, { displayOrder: Number(event.target.value) || 0 })} />
					</label>
					<button className="hud-subtle-button" onClick={() => removeField(field.fieldId)} type="button">{t('removeField')}</button>
				</div>
			))}
			<button className="hud-subtle-button" onClick={() => onChange([...fields, { fieldId: `field-${fields.length + 1}`, label: 'New field', value: '', valueType: 'text', displayOrder: fields.length }])} type="button">
				{t('addField')}
			</button>
		</section>
	);
}
